/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 * */

/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 * */

/**
 * @description generated: list of files importing the export below
 * @link file://./../../bundles/admin-dashboard/routes.tsx
 */
export { default as LearnersPage } from './components/LearnersPage';
/**
 * @description generated: list of files importing the export below
 * @link file://./../../bundles/admin-dashboard/routes.tsx
 */
export { default as ProgramLearnersPage } from './components/ProgramLearnersPage';
/**
 * @description generated: list of files importing the export below
 * @link file://./../../bundles/enterprise-admin-user-filters/utils.ts
 */
export type { LearnerStatus } from './types';
/**
 * @description generated: list of files importing the export below
 * @link file://./../../bundles/admin-dashboard/routes.tsx
 */
export const LearnersPageDynamic = () => import('./components/LearnersPage');
/**
 * @description generated: list of files importing the export below
 * @link file://./../../bundles/admin-dashboard/routes.tsx
 */
export const ProgramLearnersPageDynamic = () => import('./components/ProgramLearnersPage');

/**
 *  #################################### Generated content ####################################
 * */

// Shared learner-list infra (ENTADMIN-1814), consumed by the Group Details +
// All Learners shells. Hand-maintained below the deppy-generated block.
export { useLearnerListController } from './hooks/useLearnerListController';
export type { LearnerListController, LearnerListScope } from './hooks/useLearnerListController';
export { useAllLearnersQuery } from './hooks/useAllLearnersQuery';
export { LearnerListView } from './components/LearnerListView';
export { UpdateAttributesDialogV2 } from './components/update-attributes/UpdateAttributesDialogV2';
export { useLearnerMutations } from './hooks/useLearnerMutations';
export { useLearnersQuery } from './hooks/useLearnersQuery';
export { useAssignContent } from './hooks/useAssignContent';
export { useDownloadLearnersCsv } from './hooks/useDownloadLearnersCsv';
export { buildSingleMembershipAudienceUserFilter } from './utils';
export type { Learner } from './types';

// Org-level invite flow scaffolding (ENTADMIN-1951), consumed by Home, All Learners,
// and Group Details. Hand-maintained below the deppy-generated block.
export { default as InviteLearnersModal } from './components/invite-learners/InviteLearnersModal';
export type { InviteLearnersModalProps } from './components/invite-learners/InviteLearnersModal';
export { default as InviteLearnersModalProvider } from './components/invite-learners/InviteLearnersModalProvider';
export type {
  InviteLearnersModalApi,
  OpenInviteLearnersModalInput,
} from './components/invite-learners/InviteLearnersModalContext';
export type { InviteEntryPoint } from './components/invite-learners/types';
export { default as useInviteLearnersModal } from './hooks/useInviteLearnersModal';

// Domain allowlisting (ENTADMIN-1956), consumed by the Groups listing to conditionally offer a
// "Copy join link" action. Hand-maintained below the deppy-generated block.
export { useDomainAllowlistedProgramIds } from './hooks/useDomainAllowlistedProgramIds';
